module.exports = __webpack_public_path__ + "img/antes_despues_171.9cf54f5c.png";